/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ value: NonNullable<unknown> }} Ccsl_Export_Metadata_Drop_FrameInputs */

const en_ccsl_export_metadata_drop_frame = /** @type {(inputs: Ccsl_Export_Metadata_Drop_FrameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Drop Frame: ${i?.value}`)
};

const fr_ccsl_export_metadata_drop_frame = /** @type {(inputs: Ccsl_Export_Metadata_Drop_FrameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Drop Frame : ${i?.value}`)
};

const de_ccsl_export_metadata_drop_frame = /** @type {(inputs: Ccsl_Export_Metadata_Drop_FrameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Drop Frame: ${i?.value}`)
};

const it_ccsl_export_metadata_drop_frame = /** @type {(inputs: Ccsl_Export_Metadata_Drop_FrameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Riquadro di caduta: ${i?.value}`)
};

const ru_ccsl_export_metadata_drop_frame = /** @type {(inputs: Ccsl_Export_Metadata_Drop_FrameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Drop Frame: ${i?.value}`)
};

const es_ccsl_export_metadata_drop_frame = /** @type {(inputs: Ccsl_Export_Metadata_Drop_FrameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fotograma a eliminar: ${i?.value}`)
};

const zh_cn2_ccsl_export_metadata_drop_frame = /** @type {(inputs: Ccsl_Export_Metadata_Drop_FrameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`帧丢失：${i?.value}`)
};

const ja_ccsl_export_metadata_drop_frame = /** @type {(inputs: Ccsl_Export_Metadata_Drop_FrameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ドロップフレーム: ${i?.value}`)
};

const hi_ccsl_export_metadata_drop_frame = /** @type {(inputs: Ccsl_Export_Metadata_Drop_FrameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ड्रॉप फ्रेम: ${i?.value}`)
};

const pt_pt2_ccsl_export_metadata_drop_frame = /** @type {(inputs: Ccsl_Export_Metadata_Drop_FrameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Drop Frame: ${i?.value}`)
};

/**
* | output |
* | --- |
* | "Drop Frame: {value}" |
*
* @param {Ccsl_Export_Metadata_Drop_FrameInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_metadata_drop_frame = /** @type {((inputs: Ccsl_Export_Metadata_Drop_FrameInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Metadata_Drop_FrameInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ccsl_export_metadata_drop_frame(inputs)
	if (locale === "de") return de_ccsl_export_metadata_drop_frame(inputs)
	if (locale === "it") return it_ccsl_export_metadata_drop_frame(inputs)
	if (locale === "ru") return ru_ccsl_export_metadata_drop_frame(inputs)
	if (locale === "es") return es_ccsl_export_metadata_drop_frame(inputs)
	if (locale === "zh-CN") return zh_cn2_ccsl_export_metadata_drop_frame(inputs)
	if (locale === "ja") return ja_ccsl_export_metadata_drop_frame(inputs)
	if (locale === "hi") return hi_ccsl_export_metadata_drop_frame(inputs)
	if (locale === "pt-PT") return pt_pt2_ccsl_export_metadata_drop_frame(inputs)
	return en_ccsl_export_metadata_drop_frame(inputs)
});